module.exports = __webpack_public_path__ + "img/complete.625c64e8.svg";